import { render, staticRenderFns } from "./PrgParamManage.vue?vue&type=template&id=0207bb6d&scoped=true&"
import script from "./PrgParamManage.vue?vue&type=script&lang=js&"
export * from "./PrgParamManage.vue?vue&type=script&lang=js&"
import style0 from "./PrgParamManage.vue?vue&type=style&index=0&id=0207bb6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0207bb6d",
  null
  
)

export default component.exports